import { createContext } from 'react';

export const IsFormSaved = createContext('');
